/**
 * Base64 of binary data, for sending files (a plugin's `.wasm`) inside the JSON frames.
 */

/** How many bytes are turned into characters at a time (keeps `String.fromCharCode` arguments small). */
const CHUNK = 0x8000;

/** The base64 text of `bytes`. */
export function toBase64(bytes: Uint8Array): string {
  let binary = "";
  for (let i = 0; i < bytes.length; i += CHUNK) {
    binary += String.fromCharCode(...bytes.subarray(i, i + CHUNK));
  }
  return btoa(binary);
}

/** The bytes of a base64 text. */
export function fromBase64(text: string): Uint8Array {
  const binary = atob(text);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes;
}
